export default __webpack_public_path__ + "static/52ed7b2d-8a31-4b18-a1d5-8685608b0889-3a8df146b6b8e37863eeffed878feab5.woff";